import React from "react";
import { FlightSearchFormProps } from "./types";
import TripTypeSelector from "./TripTypeSelector";
import SearchFields from "./SearchFields";

const FlightSearchForm: React.FC<FlightSearchFormProps> = ({
    searchState,
    onSearchStateChange,
    onSearch,
}) => {
    const isSearchEnabled =
        searchState.departure &&
        searchState.destination &&
        searchState.departureDate &&
        (searchState.tripType === "one-way" || searchState.returnDate) &&
        searchState.passengers;

    return (
        <div className="px-6 lg:px-8 py-6">
            <TripTypeSelector
                tripType={searchState.tripType}
                setTripType={(tripType) => onSearchStateChange({ tripType })}
                bookWithMiles={searchState.bookWithMiles}
                setBookWithMiles={(bookWithMiles) =>
                    onSearchStateChange({ bookWithMiles })
                }
            />

            <SearchFields
                searchState={searchState}
                onSearchStateChange={onSearchStateChange}
            />

            {/* Promo Code and Search Button - Desktop and landscape */}
            <div className="hidden lg:flex landscape:flex justify-between items-center pt-6">
                <button
                    className="hover:underline text-sm font-medium underline"
                    style={{ color: "#0047ba" }}
                >
                    Add promo code
                </button>

                <button
                    onClick={onSearch}
                    disabled={!isSearchEnabled}
                    className={`px-10 py-3 rounded-md font-semibold text-base transition-colors ${
                        isSearchEnabled
                            ? "text-white"
                            : "bg-gray-300 cursor-not-allowed"
                    }`}
                    style={
                        isSearchEnabled
                            ? { backgroundColor: "#0047ba" }
                            : { color: "#011d4f" }
                    }
                    onMouseEnter={(e) => {
                        if (isSearchEnabled) {
                            e.currentTarget.style.backgroundColor = "#003a96";
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (isSearchEnabled) {
                            e.currentTarget.style.backgroundColor = "#0047ba";
                        }
                    }}
                >
                    Search flights
                </button>
            </div>

            {/* Mobile Layout - Hidden in landscape */}
            <div className="lg:hidden landscape:hidden">
                {/* Add promo code link */}
                <div className="border-t border-b border-gray-300 py-5 -mx-6 px-6 mt-4">
                    <button
                        className="text-sm font-medium underline"
                        style={{ color: "#0047ba" }}
                    >
                        Add promo code
                    </button>
                </div>

                {/* Search Button - Full width on mobile */}
                <button
                    onClick={onSearch}
                    disabled={!isSearchEnabled}
                    className={`w-full py-4 rounded-lg font-semibold text-base transition-colors mt-6 ${
                        isSearchEnabled
                            ? "text-white"
                            : "bg-gray-200 cursor-not-allowed"
                    }`}
                    style={
                        isSearchEnabled
                            ? { backgroundColor: "#0047ba" }
                            : { color: "#111827" }
                    }
                >
                    Search flights
                </button>
            </div>
        </div>
    );
};

export default FlightSearchForm;
